module.exports = __webpack_public_path__ + "static/media/teygja_armbeygja.58573786.png";